import React from 'react';
import { Hero } from '../components/home/Hero';
import { AboutSection } from '../components/home/AboutSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { ProcessSection } from '../components/home/ProcessSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { ContactSection } from '../components/home/ContactSection';
export function Home() {
  return <>
      <Hero data-id="element-206" data-mp="1zjs6fu2r2n4i" />
      <AboutSection data-id="element-207" data-mp="1zk1uhc48ik7k" />
      <ServicesSection data-id="element-208" data-mp="24gscw63ihrw5" />
      <ProcessSection data-id="element-209" data-mp="24g8w4spll9jp" />
      <TestimonialsSection data-id="element-210" data-mp="24hk8hgx3zpmf" />
      <ContactSection data-id="element-211" data-mp="24ivbvfmn6vd0" />
    </>;
}